import { Body, Spacer } from '@spritz-finance/ui'
import styled, { css } from 'styled-components'
import { cssVar } from '../theme/utils'
import { Row } from './Layout/Row'

const ValueRow = styled(Row)`
    width: 100%;
    align-items: center;
    background: var(--surface-3, rgba(255, 255, 255, 0.85));
    padding: 4px;
    box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.08);
    border-radius: 30px;
`

const TextPill = styled.div<{ $color: string; width?: string }>`
    background: ${({ $color }) => $color};
    border-radius: 25px;
    padding: 8px 16px;
    ${({ width }) =>
        width &&
        css`
            width: ${width};
        `}
`

export const KeyValuePill: React.FC<{
    keyText: string
    color: string
    width?: string
}> = ({ keyText, color, children, width }) => {
    return (
        <ValueRow>
            <TextPill $color={cssVar('--surface-2', color)} width={width}>
                <Body.Med size={14}>{keyText}</Body.Med>
            </TextPill>
            <Spacer width={8} />
            {children}
            <Spacer width={24} />
        </ValueRow>
    )
}
